import moment, { Moment } from "moment";

export const getAirportOptions = (data: Airport[]): SelectOption[] => data.map((airport) => ({
  label: airport.Name,
  value: airport.Code,
  tags: `${airport.StateCode} ${airport.StateName}`,
}));

export const generateFlightSearchInputs = (numberOfInputs: number) => {
  const flightFields = new Array(numberOfInputs).fill({
    OriginLocationCode: '',
    DestinationLocationCode: '',
    DepartureDate: '',
  });

  return flightFields.map(({
    OriginLocationCode,
    DestinationLocationCode,
    DepartureDate,
  }, key) => ({
    id: key,
    OriginLocationCode,
    DestinationLocationCode,
    DepartureDate,

  }));
};

export const generateMultiCityFlightRoutes = (routes) => routes.map(((route) => ({
  DepartureDate: route.DepartureDate?.from ? route.DepartureDate.from : route.DepartureDate,
  OriginLocationCode: route.OriginLocationCode,
  DestinationLocationCode: route.DestinationLocationCode,
})
));


export const validateRoundTripDates = (_, value) => {
  value = value || [];
  value = value.filter((item) => item !== undefined);

  if (value.length !== 2) {
    return Promise.reject(new Error('Please select departure and return date'));
  }
  return Promise.resolve();
};


export const getDateFromValue = (value: any): Date | undefined => {
  if (!value) return undefined;

  const rawValue = value?.from ?? value?.value ?? value;

  if (!rawValue) return undefined;

  if (rawValue instanceof Date) {
    return Number.isNaN(rawValue.getTime()) ? undefined : rawValue;
  }

  if (moment.isMoment(rawValue)) {
    return rawValue.toDate();
  }

  const date = new Date(rawValue);
  return Number.isNaN(date.getTime()) ? undefined : date;
};

export const getMinSelectableMultiCityDate = (
  form: any,
  fieldName: number
): Date => {
  if (fieldName <= 0) return new Date();

  const previousTripDate = getDateFromValue(
    form.getFieldValue(["trips", fieldName - 1, "DepartureDate"])
  );

  return previousTripDate ?? new Date();
};

export const getMultiCityDisabledDate = (
  current: Moment,
  form: any,
  fieldName: number,
  getDisabledDateRange: (current: Moment, startDate?: Moment) => boolean
): boolean => {
  const minSelectableDate = getMinSelectableMultiCityDate(form, fieldName);

  return getDisabledDateRange(current, moment(minSelectableDate));
};
